import { useRef, useEffect } from 'react';

// Plotly는 CDN(window.Plotly)에서 로드됨
// deps 배열의 값이 바뀔 때마다 차트를 재그린다
export default function usePlotly(buildTrace, deps) {
  const ref = useRef(null);

  useEffect(() => {
    const Plotly = window.Plotly;
    if (!Plotly || !ref.current) return;

    const { data, layout } = buildTrace();

    const baseLayout = {
      paper_bgcolor: '#fffdf8',
      plot_bgcolor:  'rgba(255,250,243,0.6)',
      font: { color: '#3b2417', family: 'Pretendard, "Noto Sans KR", system-ui, sans-serif', size: 12 },
      margin: { l: 64, r: 20, t: 40, b: 48 },
      legend: { bgcolor: 'transparent', font: { color: '#9a8778' } },
      ...layout,
    };

    const el = ref.current;
    Plotly.newPlot(el, data, baseLayout, {
      responsive: true,
      displayModeBar: false,
    });

    return () => {
      Plotly.purge(el);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return ref;
}
